export const routes = {
  search: '/algolia/search',
}
